const data=[
    {
        image:'blog1.png',
        type:"content",
        category:"✍️ Article",
        heading:"What if famous brands had regular fonts? Meet RegulaBrands!",
        paragraph:"I’ve worked in UX for the better part of a decade. From now on, I plan to rei…",
        profile:"profile1.png",
        name:"Sarthak Kamra",
        date:"Fri, 12 Oct, 2018",
        place:"Ahmedabad, India",
        views:"1.4k"

    },
    {
        image:'blog2.png',
        type:"content",
        category:"🔬 Education",
        heading:"Tax Benefits for Investment under National Pension Scheme",
        paragraph:"I’ve worked in UX for the better part of a decade. From now on, I plan to rei…",
        profile:"profile4.png",
        name:"Sarah West",
        date:"Fri, 12 Oct, 2018",
        place:"Ahmedabad, India",
        views:"1.4k"

    },
    {
        image:'blog1.png',
        type:"content",
        category:"✍️ Article",
        heading:"What if famous brands had regular fonts? Meet RegulaBrands!",
        paragraph:"I’ve worked in UX for the better part of a decade. From now on, I plan to rei…",
        profile:"profile2.png",
        name:"kunal kamra",
        date:"Fri, 12 Oct, 2018",
        place:"Ahmedabad, India",
        views:"1.4k"

    },
    {
        image:'blog3.png',
        type:"non-content",
        category:"🗓️ Meetup",
        heading:"Finance & Investment Elite Social Mixer @Lujiazui",
        paragraph:"I’ve worked in UX for the better part of a decade. From now on, I plan to rei…",
        profile:"profile3.png",
        name:"Ronal Jones",
        date:"Fri, 12 Oct, 2018",
        place:"Ahmedabad, India",
        views:"1.4k"

    },
    {
        image:'blog3.png',
        type:"non-content",
        category:"💼️ Job",
        heading:"Software Developer",
        paragraph:"I’ve worked in UX for the better part of a decade. From now on, I plan to rei…",
        profile:"profile2.png",
        name:"Joseph Gray",
        date:"Innovaccer Analytics Private Ltd.",
        place:"Noida, India",
        views:"1.4k"

    },
    {
        image:'blog2.png',
        type:"non-content",
        category:"💼️ Job",
        heading:"Software Developer",
        paragraph:"I’ve worked in UX for the better part of a decade. From now on, I plan to rei…",
        profile:"profile1.png",
        name:"kunal kamra",
        date:"Google INC",
        place:"Noida, India",
        views:"1.4k"

    },
]

export default data;